import { Suspense, lazy } from "react";
import { Navigate, useRoutes, useLocation } from "react-router-dom";
// loadibng components
import LoadingScreen from "./../components/LoadingScreen";
import AuthGuard from "../guards/AuthGuard";
import { productRoutes } from "./product";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("/dashboard")} />}
    >
      <Component {...props} />
      {/* <LoadingScreen isDashboard={pathname.includes("/dashboard")} /> */}
    </Suspense>
  );
};

//supplier quote request
const SupplierQuotations = Loadable(
  lazy(() => import("./../pages/Quotes/SupplierQuotations"))
);
const SupplierOrdersPage = Loadable(
  lazy(() => import("./../pages/suppliers/Orders/SupplierOrdersPage"))
);

const OrderDetails = Loadable(lazy(() => import("../pages/Orders/OrderDetails")));


export const supplierRoutes = [
  {
    path: "quotations",
    element: (
      <AuthGuard>
        <SupplierQuotations />
      </AuthGuard>
    ),
  },
  {
    path: "orders",
    element: (
      <AuthGuard>
        <SupplierOrdersPage />
      </AuthGuard>
    ),
  },
  {
    path: "orders/:id",
    element: (
      <AuthGuard>
        <OrderDetails />
      </AuthGuard>
    )
  },
  ...productRoutes
];
